import { render, staticRenderFns } from "./ContactoTK.vue?vue&type=template&id=3ffc0ef7&scoped=true&"
import script from "./ContactoTK.vue?vue&type=script&lang=js&"
export * from "./ContactoTK.vue?vue&type=script&lang=js&"
import style0 from "./ContactoTK.vue?vue&type=style&index=0&id=3ffc0ef7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc0ef7",
  null
  
)

export default component.exports